var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiftIconPurple = function SvgGiftIconPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 5a1.5 1.5 0 1 1 0-3c.344 0 1.018.037 1.635.963.103.156.225.398.365.725.14-.327.262-.569.365-.725C10.482 2.037 11.156 2 11.5 2a1.5 1.5 0 0 1 0 3H15a1 1 0 0 1 1 1v3h-1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3V6a1 1 0 0 1 1-1h3.5ZM4 6v2h5V6H4Zm6 0v2h5V6h-5ZM5 9v5h5V9H5Zm5 0v5h4V9h-4Zm1.5-4.75a.75.75 0 0 0 0-1.5c-.406 0-.667.113-1.01.629-.1.151-.24.445-.41.871h1.42Zm-4 0h1.42c-.17-.426-.31-.72-.41-.871-.343-.516-.603-.629-1.01-.629a.75.75 0 0 0 0 1.5Z",
    fill: "#9A27D5"
  })));
};
export default SvgGiftIconPurple;